// Admin - Dashbaord.

import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import UIString from '../../assets/content/UIString';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavBar from '../../lib-ui/admin/NavBar';
import Alert from '@mui/material/Alert';
import Util from '../../lib/Util';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useNavigate } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import Chip from '@mui/material/Chip';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Block1Icon from '@mui/icons-material/Block';
import IOSSwitch from '../../lib-ui/common/IOSSwitch';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
//import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import Pagination from '@mui/material/Pagination';
import PagePanel from '../../lib-ui/common/PagePanel';
import SearchBar from '../../lib-ui/admin/SearchBar';
import { useSearchParams } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Divider from '@mui/material/Divider';
import '../../assets/style/common.css';
import '../../assets/style/admin.css';
import SectionNavButton from '../../lib-ui/common/SectionNavButton';



const lang = Util.get_lang();

export default () => {

    // const navigate = useNavigate();

    const [navTitle, setNavTitle] = useState('');
    const [flagContent, setFlagContent] = useState('');
    const [flagToast, setFlagToast] = useState(false);
    const [toastMsg, setToastMsg] = useState();
    const [toastModeIcon, setToastModeIcon] = useState();
    const closeToast = () => { flagToast ? setFlagToast(false) : setFlagToast(true); }
    const showToast = (mode, msg) => {
        switch (mode) {
            case 'info': setToastModeIcon(<InfoIcon sx={{ fontSize: '32px', color: '#66ff66' }} />); break;
            case 'warning': setToastModeIcon(<WarningIcon sx={{ fontSize: '18px', color: '#6666ff' }} />); break;
        }

        setToastMsg(msg);
        setFlagToast(true);
    }

    const [statData, setStatData] = useState({
        signup_requests: {},
        users: {},
        signout_requests: {},
        activities: {}

    });





    useEffect(() => {

        setNavTitle([UIString[lang]['NAV_USER']]);
        load_data();

    }, []);




    function load_data() {

        let url = Util.api_url(lang, '/admin/user');// '/'+lang+'/api/v1/admin/user';

        // Get data.
        let form = new FormData;
        Util.get(
            url,
            (data) => {
                console.log(data);
                setStatData(data);

                //setSignupRequests(data.signup_requests);
            },
            (err) => {
                alert(err + '336');
            }
        );
    }









    const nav_links = [{ label: 'Home', url: '/' + lang + '/admin/dashboard' }, { label: 'Dashboard', url: '/Dashboard' }];

    return (
        <>
            <Header code={'user'} />
            <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px', textAlign: 'center', backgroundColor: '#ffffff', margin: '0px auto' }}>
                <Stack className='page_title' direction={'row'}>
                    <NavBar text={navTitle} key={navTitle} />
                    <span className='nav_right_button'>test 0</span>
                    <span className='nav_right_button'>test 1</span>
                </Stack>

                <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px', display: `${flagContent}` }}>
                    <br />
                    <Stack className='page_title' direction={'row'} sx={{ height: '30px' }}>
                        <div className={'section_title'} sx={{ height: '20px' }}>◼&nbsp;&nbsp;{UIString[lang]['SIGNUP_REQUESTS']}</div>
                        <SectionNavButton label={UIString[lang]['LIST']} url={Util.page_url(lang,'/admin/user/signup/request/list/1')}  />
                    </Stack>
                    <Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /><br />
                    <table style={{ width: '600px', border: 'none', borderCollapse: 'collapse' }} >
                        <tr>
                            <td className='outline_cell' style={{ width: '120px', textAlign: 'right', paddingRight: '8px' }} >
                                Total
                            </td>
                            <td className='outline_cell'>
                                {statData.signup_requests.total}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Waiting
                            </td>
                            <td className='outline_cell'>
                                {statData.signup_requests.waiting}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Confirmed
                            </td>
                            <td className='outline_cell'>
                                {statData.signup_requests.confirmed}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Expired
                            </td>
                            <td className='outline_cell'>
                                {statData.signup_requests.expired}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Unknown
                            </td>
                            <td className='outline_cell'>
                                {statData.signup_requests.unknown}
                            </td>
                        </tr>
                    </table>
                    <br /><br />


                    <Stack className='page_title' direction={'row'} sx={{ height: '30px' }}>
                        <div className={'section_title'}>◼&nbsp;&nbsp;{UIString[lang]['USERS']}</div>
                        <SectionNavButton label={UIString[lang]['LIST']} url={Util.page_url(lang,'/admin/user/list/1')}  />
                    </Stack>
                    <Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /><br />
                    <table style={{ width: '600px', border: 'none', borderCollapse: 'collapse' }} >
                        <tr>
                            <td className='outline_cell' style={{ width: '120px', textAlign: 'right', paddingRight: '8px' }} >
                                Total
                            </td>
                            <td className='outline_cell'>
                                {statData.users.total}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Active
                            </td>
                            <td className='outline_cell'>
                                {statData.users.active}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Inactive
                            </td>
                            <td className='outline_cell'>
                                {statData.users.inactive}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Deleted
                            </td>
                            <td className='outline_cell'>
                                {statData.users.deleted}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Unknown
                            </td>
                            <td className='outline_cell'>
                                {statData.users.unknown}
                            </td>
                        </tr>
                    </table>
                    <br /><br />

                    <Stack className='page_title' direction={'row'} sx={{ height: '30px' }}>
                        <div className={'section_title'}>◼&nbsp;&nbsp;{UIString[lang]['SIGNOUT_REQUESTS']}</div>
                        <SectionNavButton label={UIString[lang]['LIST']} url={Util.page_url(lang,'/admin/user/signout/request/list/1')}  />
                    </Stack>
                    <Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /><br />
                    <table style={{ width: '600px', border: 'none', borderCollapse: 'collapse' }} >
                        <tr>
                            <td className='outline_cell' style={{ width: '120px', textAlign: 'right', paddingRight: '8px' }} >
                                Total
                            </td>
                            <td className='outline_cell'>
                                {statData.signout_requests.unknown}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Waiting
                            </td>
                            <td className='outline_cell'>
                                {statData.signout_requests.waiting}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Confirmed
                            </td>
                            <td className='outline_cell'>
                                {statData.signout_requests.confirmed}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Expired
                            </td>
                            <td className='outline_cell'>
                                {statData.signout_requests.expired}
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Unknown
                            </td>
                            <td className='outline_cell'>
                                {statData.signout_requests.unknown}
                            </td>
                        </tr>
                    </table>
                    <br /><br />

                    <Stack className='page_title' direction={'row'} sx={{ height: '30px' }}>
                        <div className={'section_title'}>◼&nbsp;&nbsp;{UIString[lang]['ACTIVITIES']}</div>
                        
                    </Stack>
                    <Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /><br />
                    <table style={{ width: '600px', border: 'none', borderCollapse: 'collapse' }} >
                        <tr>
                            <td className='outline_cell' style={{ width: '120px', textAlign: 'right', paddingRight: '8px' }} >
                                Total
                            </td>
                            <td className='outline_cell'>
                                {statData.activities.total}
                            </td>
                        </tr>
                        {/*<tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Waiting
                            </td>
                            <td className='outline_cell'>
                                1,890
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Confirmed
                            </td>
                            <td className='outline_cell'>
                                1,890
                            </td>
                        </tr>
                        <tr>
                            <td className='outline_cell' style={{ textAlign: 'right', paddingRight: '8px' }} >
                                Unknown
                            </td>
                            <td className='outline_cell'>
                                1,890
                            </td>
                        </tr>*/}
                    </table>
                    <br /><br />




                    <br />

                </Paper>

                {flagContent == 'none' ? <Box sx={{ width: '100%', height: '600px', textAlign: 'center', fontSize: '13px' }}>
                    <WarningIcon style={{ fontSize: '80px', marginTop: '180px', marginBottom: '22px' }} /><br />
                    {UIString[lang]['NO_DATA']}
                </Box> : <></>}

                <div style={{ height: '600px' }}>&nbsp;&nbsp;</div>
                <Snackbar
                    sx={{}}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={flagToast}
                    onClose={closeToast}
                    autoHideDuration={1800}
                    key={'top' + 'center'}
                >
                    <SnackbarContent
                        sx={{
                            backgroundColor: '#fcfcfc',
                            color: '#222222',
                            minHeight: '60px',
                            fontSize: '13px',
                            display: "flex",
                            justifyContent: "space-between", // Space between text and icon
                            alignItems: "center",
                        }}

                        message={<Box display="flex" alignItems="center">
                            {toastModeIcon}&nbsp;&nbsp;
                            <span>{toastMsg}</span>
                        </Box>}
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => console.log("Close clicked")}
                            >
                                <CloseIcon sx={{ cursor: 'pointer', fontSize: '18px', color: '#222222' }} onClick={() => { closeToast() }} />
                            </IconButton>}

                    />
                </Snackbar>









            </div>
        </>
    );

}